module.exports = __webpack_public_path__ + "src/assets/img/cd02.6579ac6b.png";